var map = {
  "./FlavourList/store/index.ts": [
    "6550",
    "545",
    "859"
  ],
  "./FlavourList/components/FlavourModal/index.ts": [
    "947",
    "545",
    "468"
  ],
  "./FAQs/components/FAQList/index.ts": [
    "1803",
    "545",
    "796"
  ],
  "./FlavourList/components/FlavourCard/index.ts": [
    "4665",
    "545",
    "42"
  ],
  "./FlavourList/components/IconGrid/index.ts": [
    "4390",
    "699"
  ],
  "./FlavourList/index.ts": [
    "7706",
    "545",
    "773"
  ],
  "./shared/components/TaxonomyList/index.ts": [
    "3391",
    "545",
    "4"
  ],
  "./shared/components/TaxonomyToggle/index.ts": [
    "1962",
    "545",
    "551"
  ],
  "./FAQs/components/FAQItem/index.ts": [
    "70",
    "545",
    "345"
  ],
  "./FlavourList/components/NutritionGrid/index.ts": [
    "6601",
    "34"
  ],
  "./FAQs/index.ts": [
    "4978",
    "545",
    "701"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 2781;
module.exports = __rspack_async_context;
